import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';

/**
 * Where the sidebar chat draws its composer (`ChatRunnerView`): inset from the column's edges,
 * above the bottom space. The sidebar's loading state draws the composer's box at the same spot.
 */
export const CHAT_COMPOSER_FRAME_CLASS = 'px-3 pb-4 md:pb-6';

/**
 * The composer's box (`MultimodalInput`), at least as tall as when it is empty: two rows of text
 * and its footer.
 */
export const CHAT_COMPOSER_BOX_CLASS = 'min-h-[104px] overflow-hidden border border-border/40 bg-muted/80';

/**
 * The chat's empty composer box, where and as the chat draws it, for the sidebar to show while the
 * chat cannot yet, so the chat takes its place without anything appearing.
 */
export function ChatComposerSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden="true" data-testid="chat-composer-skeleton" className={cn("flex min-w-0 flex-1 flex-col justify-end", CHAT_COMPOSER_FRAME_CLASS)}><div className={cn("rounded-sm", CHAT_COMPOSER_BOX_CLASS)} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}